import * as Yup from 'yup';

export const blogSchema = Yup.object({
  title: Yup.string().required(),
  hash_tag: Yup.string(),
});

export const blogFormikForm = {
  title: '',
  hash_tag: '',
};
